import React from "react";
import { ScreenNameList } from "@lib/utilities/Constants";
import { withPolicyDataFetching } from "../../hoc/withFetchPolicyData";
import { useContactAgent } from "@lib/hooks/contactAgent/useContactAgent";
import PageWrapper from "../../components/common/PageWrapper";
import ContactAgentView from "../../components/contactAgent/ContactAgentView";
import { formattedMailingAddress } from "@lib/utilities/Formatters";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { Platform } from "react-native";
import MainContainer from "../../components/common/MainContainer";

const ContactAgent = ({ navigation }: any) => {
  const {
    errorData,
    onEndTimer,
    agent,
    loading,

    policyNumber,
    policyList,
    findUsMapURL,
    onReloadPress,
  } = useContactAgent();

  return (
    <MainContainer
      screenName={ScreenNameList.contactAgent}
      navigation={navigation}
      errorData={errorData}
      onReloadPress={onReloadPress}
      onEndTimer={onEndTimer}
    >
      <PageWrapper
        screenName={ScreenNameList.contactAgent}
        navigation={navigation}
        isLoading={loading}
        arrayPolicyList={policyList}
      >
        {!loading && policyNumber != "" ? (
          <ContactAgentView
            findUsMapURL={findUsMapURL}
            physicalAddress={formattedMailingAddress(agent?.mailingAddress)}
            mailingAddress={formattedMailingAddress(agent?.mailingAddress)}
            agentDetails={agent}
            agencyName={agent?.agencyName}
          />
        ) : (
          <></>
        )}
      </PageWrapper>
    </MainContainer>
  );
};

export default Platform.OS=='web'?withAuthenticationRequired(withPolicyDataFetching(ContactAgent)):withPolicyDataFetching(ContactAgent);
